/* @flow */

import moment from 'moment';
import { type State } from '../preact-app/types';
import { type RelogioState } from './relogio-types';
import { MOMENT_FORMATO_BANCO } from '../utils/constants';

type Action = {
    type: 'relogio/TICK_TACK',
}

// Action Types

const TICK_TACK = 'relogio/TICK_TACK';

// Action Creators

export const tickTack = () => ({ type: TICK_TACK });

// Thunk

export const iniciarRelogio = () => (dispatch: Function) => (
    setInterval(() => dispatch(tickTack()), 5000)
);

// Selectors

export const getRelogio = (state: State) => state.relogio;

export const getRelogioFormatoBanco = (state: State) => (
    moment(getRelogio(state)).format(MOMENT_FORMATO_BANCO)
);

export const getHora = (state: State) => (
    moment(getRelogio(state)).format('HH:mm')
);

const HORA_EM_MILISEGUNDOS = 3.6e+6;

const getTime = () => {
    const date = new Date();
    if (date.getTimezoneOffset && date.getTimezoneOffset() === 120) {
        date.setTime(date.getTime() - HORA_EM_MILISEGUNDOS);
    }
    return date.getTime();
};

const relogioReducer = (state: RelogioState = getTime(), action: Action): RelogioState => (
    action.type === TICK_TACK ? getTime() : state
);

export default relogioReducer;
